import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1065SchK1 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Schedule K-1 (Form 1065) Guide: Boxes, Rules & Instructions"
          description="Learn Schedule K-1 (Form 1065) basics, income boxes, deductions, basis tracking, QBI rules, deadlines, and filing tips for partners and tax professionals."
          keywords=""
          canonical="resources/business-tax/schedule-k1-1065/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          {' '}
          <span className="highlight-container">
            <span className="highlight">Schedule K-1 (Form 1065):</span>
          </span>{' '}
          The Complete Resource Guide for Partners & Tax Professionals
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/schedule-k1-1065/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule K-1 (Form 1065) at a Glance
                  </Typography>

                  <Box
                    component="ul"
                    itemProp="articleBody"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Learn who must file Form 1065 and issue Schedule K-1s,
                        </strong>{' '}
                        including general partnerships, limited partnerships,
                        LLPs, and multi-member LLCs taxed as partnerships.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore how to complete Schedule K-1 (Form 1065)
                        </strong>{' '}
                        with detailed explanations of Part I, Part II, and Part
                        III items, including partner information, ownership
                        details, and allocated tax items.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand how Schedule K-1 affects partner tax
                          reporting,
                        </strong>{' '}
                        including pass-through taxation, basis tracking, at-risk
                        limitations, passive activity rules, and reporting
                        requirements.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Schedule K-1 (Form 1065) is a federal tax document issued
                      by partnerships to each partner at the end of the tax
                      year. It reports each partner's allocated share of the
                      partnership's income, deductions, credits, and other tax
                      items. Rather than paying taxes at the entity level,
                      partnerships pass their financial results through to
                      individual partners — a structure known as{' '}
                      <span style={{ fontWeight: 600 }}>
                        pass-through taxation
                      </span>
                      . The Schedule K-1 is the mechanism that makes this
                      possible.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Whether you're a general partner managing day-to-day
                      operations or a limited partner who simply invested
                      capital, you'll receive a K-1 if you hold any ownership
                      interest in a partnership that filed{' '}
                      <Link
                        href="/business-tax/efile-irs-form-1065-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        Form 1065
                      </Link>{' '}
                      with the IRS.
                    </Typography>
                  </Box>
                </Stack>
                <Box
                  sx={{
                    pt: 2,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What’s New for Schedule K-1
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#who" sx={{ color: '#0202ff' }}>
                          Who Must File Form 1065 and Issue K-1s?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#why" sx={{ color: '#0202ff' }}>
                          Why Schedule K-1 Matters for Partners
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#line" sx={{ color: '#0202ff' }}>
                          Line-by-Line Instruction for Schedule K-1
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#schk" sx={{ color: '#0202ff' }}>
                          Schedule K vs. Schedule K-1: What's the Difference?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#rules" sx={{ color: '#0202ff' }}>
                          At-Risk Rules and Passive Activity Rules
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whento" sx={{ color: '#0202ff' }}>
                          When to Expect Your Schedule K-1
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Mistakes to Avoid with Schedule K-1
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#real" sx={{ color: '#0202ff' }}>
                          Schedule K-1 and Real Estate Partnerships
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#public" sx={{ color: '#0202ff' }}>
                          Publicly Traded Partnerships (PTPs) and K-1s
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faq" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#key" sx={{ color: '#0202ff' }}>
                          Key IRS Resources for Schedule K-1 (Form 1065)
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#internal" sx={{ color: '#0202ff' }}>
                          TaxZerone Internal Resources for Partnerships
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What’s New for Schedule K-1
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The IRS has made the following changes to Schedule K-1 (Form
                  1065)
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Box 13 Code X – Extra Deduction for Production Expenses
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Qualified sound recording production expenses can now be
                  reported in Box 13, Code X, in addition to qualified film and
                  television production expenses. This change allows eligible
                  partnerships to pass through these deductible expenses to
                  partners.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Box 19 – More transparent distribution reporting
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The IRS has updated the instructions for Box 19 to clarify the
                  reporting of different partnership distributions with separate
                  codes. Partners can more easily identify the type of
                  distribution they receive.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Box 20, Code ZZ – New Farmland Tax Election
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  In Box 20, a new code ZZ has been added for certain sales of
                  qualified farmland to qualified farmers. Eligible partners can
                  elect to pay the tax due on such gains in four equal annual
                  installments rather than in one year.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="who"
                >
                  Who Must File Form 1065 and Issue K-1s?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Any domestic partnership — including general partnerships,
                  limited partnerships (LPs), limited liability partnerships
                  (LLPs), and most multi-member LLCs taxed as partnerships —
                  must{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1065-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    file Form 1065
                  </Link>{' '}
                  annually. As part of that filing, the partnership is required
                  to prepare and distribute a Schedule K-1 to each partner, as
                  well as submit copies to the IRS.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Entities that issue Schedule K-1 (Form 1065) include:
                </Typography>
                <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      General partnerships —
                    </span>{' '}
                    Traditional business arrangements where all partners share
                    management responsibilities and liability.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Limited partnerships (LPs) —{' '}
                    </span>
                    Structures with at least one general partner and one or more
                    limited partners.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Limited liability partnerships (LLPs) —
                    </span>{' '}
                    Common among law firms, accounting firms, and medical
                    practices.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Multi-member LLCs (taxed as partnerships) —
                    </span>{' '}
                    LLCs with two or more members that have not elected to be
                    taxed as a corporation.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Single-member LLCs, S corporations, and trusts/estates use
                  different K-1 variants — Schedule K-1 for{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1120-s/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 1120-S
                  </Link>{' '}
                  and Form 1041, respectively.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="why"
                >
                  Why Schedule K-1 Matters for Partners
                </Typography>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  The K-1 is more than just an informational form — it directly
                  affects each partner's personal tax return. Here's why it
                  matters:
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Pass-through taxation:
                    </span>{' '}
                    The partnership itself does not pay federal income tax.
                    Instead, profits and losses "pass through" to partners, who
                    report them on their individual returns (Form 1040),
                    business returns, or corporate returns, depending on the
                    partner's entity type.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Self-employment tax:
                    </span>{' '}
                    For general partners, guaranteed payments and certain
                    ordinary income items from the K-1 may be subject to
                    self-employment tax.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      Passive activity rules:
                    </span>{' '}
                    Limited partners and certain LLC members must apply passive
                    activity loss rules to income and losses reported on their
                    K-1.
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="line"
                >
                  Line-by-Line Instructions for Schedule K-1 (Form 1065)
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part I – Information About the Partnership
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part1-infor-img.webp" />
                  <source srcSet="/assets/images/schk1-part1-infor-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part1-infor-img.png"
                    loading="lazy"
                    alt="Schedule K-1 Form 1065 Part I partnership information"
                    width={480}
                    height={363}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>

                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item A – Partnership's Employer Identification Number (EIN)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the partnership's 9-digit Employer Identification Number
                  (EIN) assigned by the IRS. Ensure the EIN matches the one
                  reported on Form 1065.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item B – Partnership's Name and Address
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the partnership's legal name and complete mailing
                  address, including the city, state, and ZIP code. This
                  information should match the partnership's tax return.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item C – IRS Center Where Partnership Filed Return
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the IRS service center where the partnership filed Form
                  1065. This identifies the IRS location that processed the
                  partnership's return.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item D – Publicly Traded Partnership (PTP)
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Check this box if the partnership is a publicly traded
                  partnership (PTP). Leave it unchecked if the partnership is
                  privately held.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part II—Information About the Partner (Item E & F)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part2-eandf-img.webp" />
                  <source srcSet="/assets/images/schk1-part2-eandf-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part2-eandf-img.png"
                    loading="lazy"
                    alt="Schedule K-1 Form 1065 Part II partner information items E and F"
                    width={458}
                    height={142}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item E – Partner's SSN or TIN
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>
                    If the partner is an individual, enter their{' '}
                    <span style={{ fontWeight: 600 }}> SSN or ITIN;</span> for
                    all other partners, enter their{' '}
                    <span style={{ fontWeight: 600 }}>EIN</span>. For a
                    <span style={{ fontWeight: 600 }}> disregarded entity</span>
                    , report the{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      beneficial owner’s TIN in Item E
                    </span>{' '}
                    and address in Item F.
                  </li>
                  <li>
                    If the partner is an{' '}
                    <span style={{ fontWeight: 600 }}> IRA,</span> enter the
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      custodian’s identifying number
                    </span>{' '}
                    . Only the{' '}
                    <span style={{ fontWeight: 600 }}>
                      last four digits
                    </span>{' '}
                    may appear on the partner copy, but the partnership reports
                    the full TIN to the IRS.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item F – Partner's Name and Address
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Enter the partner's full legal name and mailing address,
                  including the city, state, and ZIP code. The information
                  should match the taxpayer identification number entered on
                  Item E.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part II—Information About the Partner (Item G – K3)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part2-g-k3-img.webp" />
                  <source srcSet="/assets/images/schk1-part2-g-k3-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part2-g-k3-img.png"
                    loading="lazy"
                    alt="Schedule K-1 Form 1065 Part II partner information items G to K3"
                    width={458}
                    height={462}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item G – Partner Type
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Select whether the partner is a{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    General Partner or LLC Member-Manager
                  </span>{' '}
                  or a{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Limited Partner or Other LLC Member
                  </span>
                  . Choose the option that reflects the partner's role in the
                  partnership.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item H1 – Domestic or Foreign Partner
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check whether the partner is a domestic or foreign partner.
                  Select only one option based on the partner's tax status.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item H2 – Disregarded Entity Information
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>
                    Check the box only if the partner listed on Schedule K-1 is
                    a{' '}
                    <span style={{ fontWeight: 600 }}> disregarded entity</span>
                    , such as a single-member LLC that is not separately
                    taxed.{' '}
                  </li>
                  <li>
                    Enter the{' '}
                    <span style={{ fontWeight: 600 }}>
                      TIN and name of the owner
                    </span>{' '}
                    of that disregarded entity, not the LLC’s own details.{' '}
                  </li>
                </Box>
                <Alert
                  severity="info"
                  id="who"
                  icon={<InfoOutlinedIcon />}
                  sx={{ mb: 4, borderLeft: '3px solid #0288d1' }}
                >
                  <b>Tip:</b> Leave this field blank if the partner is not a
                  disregarded entity.
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item I1 – Type of Entity
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the partner entity type, such as Individual,
                  Corporation, Partnership, Trust, Estate, or LLC. Use the
                  entity classification applicable for tax purposes.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item I2 – Retirement Plan
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check this box if the partner is a qualified retirement plan,
                  such as an IRA, SEP IRA, or Keogh plan. Otherwise, leave it
                  blank.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item J – Partner's Share of Profit, Loss, and Capital
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>
                    Enter the partner’s percentage share of{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      profit, loss, and capital
                    </span>{' '}
                    at both the{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      beginning and end of the tax year.
                    </span>{' '}
                    If ownership changes during the year, update the percentages
                    to reflect the partner’s interest at year-end. If the
                    capital account is{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      zero or negative,
                    </span>{' '}
                    enter <span style={{ fontWeight: 600 }}> 0</span> on the
                    capital line.{' '}
                  </li>
                  <li>
                    If the partner sold or exchanged any part of their
                    partnership interest during the year, check the{' '}
                    <span style={{ fontWeight: 600 }}> Sale</span> or{' '}
                    <span style={{ fontWeight: 600 }}> Exchange</span>
                    box to show the reason for the decrease.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item K1 – Partner's Share of Liabilities
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the partner’s share of{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    nonrecourse liabilities, qualified nonrecourse financing,
                    and recourse liabilities
                  </span>{' '}
                  at the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    beginning and end of the tax year.
                  </span>{' '}
                  If the partner disposed of their interest during the year,
                  report the share immediately before disposition. These amounts
                  are also used to determine the partner’s basis and, in some
                  cases, at-risk amount.
                </Typography>
                <Alert
                  severity="info"
                  id="who"
                  icon={<InfoOutlinedIcon />}
                  sx={{ mb: 4, borderLeft: '3px solid #0288d1' }}
                >
                  <b>Tip:</b> Use the partnership's liability allocation
                  records.
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item K2 – Lower-Tier Partnership Liabilities
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check this box if the liability amounts reported in{' '}
                  <span style={{ fontWeight: 600 }}> Item K1</span> include
                  liabilities allocated from lower-tier partnerships.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item K3 – Guaranteed Liabilities
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Check this box if any liabilities reported in{' '}
                  <span style={{ fontWeight: 600 }}> Item K1 </span> are subject
                  to guarantees or other payment obligations by the partner.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part II—Information About the Partner (Item L – N)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part2-l-n-img.webp" />
                  <source srcSet="/assets/images/schk1-part2-l-n-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part2-l-n-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part II – Information About the Partner, Items L to N"
                    width={458}
                    height={242}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item L – Partner's Capital Account Analysis
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report the partner’s{' '}
                  <span style={{ fontWeight: 600 }}>
                    beginning and ending capital accounts
                  </span>{' '}
                  using the tax-basis method, including contributions, income or
                  loss, distributions, and other adjustments (excluding
                  liabilities). The capital account may differ from the
                  partner’s <span style={{ fontWeight: 600 }}> tax basis</span>,
                  which the partner must track separately for tax reporting
                  purposes.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item M – Built-In Gain or Loss Property
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check <span style={{ fontWeight: 600 }}> Yes</span> if the
                  partner contributed property with a built-in gain or loss to
                  the partnership. If applicable, attach the required supporting
                  statement. This information is for reporting purposes and may
                  affect your tax liability and certain Schedule K-1
                  allocations.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Item N – Net Unrecognized Section 704(c) Gain or (Loss)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report the partner’s{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    net unrecognized section 704(c) gain or loss
                  </span>{' '}
                  at the beginning and end of the tax year. This arises from
                  contributed property with built-in gain or loss or partnership
                  book-up/book-down adjustments. The amount is informational and
                  may change due to dispositions or special allocations.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <b>Note :</b> The partnership reports beginning and ending
                  balances on a{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    net aggregate basis but
                  </span>{' '}
                  must maintain detailed records{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    on a property-by-property basis
                  </span>
                  .
                </Alert>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Part III – Partner's Share of Current Year Income, Deductions,
                  Credits, and Other Items
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 1 – Ordinary Business Income (Loss)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box1-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box1-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box1-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III Ordinary Business Income (Loss)"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 0,
                    }}
                  />
                </picture>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter the partner's share of ordinary business income or
                    loss from the partnership's operations. Do not include
                    separately stated items reported in other fields.
                  </li>
                  <li>
                    If you materially participated, report it on{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Schedule E (Form 1040), Part II
                    </span>
                    . If you did not materially participate, follow{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      passive activity rules (Form 8582)
                    </span>{' '}
                    before reporting. If it is a{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      publicly traded partnership (PTP)
                    </span>
                    , special rules apply.{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 2 – Net Rental Real Estate Income (Loss)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box2-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box2-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box2-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Net Rental Real Estate Income (Loss)"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 0,
                    }}
                  />
                </picture>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter the partner's share of net income or loss from rental
                    real estate activities reported by the partnership.
                  </li>
                  <li>
                    If you are a{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      real estate professional who materially participated
                    </span>
                    , it is not passive and is reported on{' '}
                    <span style={{ fontWeight: 600 }}>
                      Schedule E (Form 1040), Part II
                    </span>
                    . Otherwise, passive income/loss rules apply (
                    <span style={{ fontWeight: 600 }}>Form 8582</span>), and
                    special limits may allow certain losses if you meet
                    eligibility conditions. If it is a{' '}
                    <span style={{ fontWeight: 600 }}>PTP</span>, special
                    reporting rules apply.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 3 – Other Net Rental Income (Loss)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box3-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box3-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box3-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Other Net Rental Income (Loss)"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 0,
                    }}
                  />
                </picture>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter the partner's share of rental income or loss from
                    rental activities other than real estate.
                  </li>
                  <li>
                    If Box 3 shows a{' '}
                    <span style={{ fontWeight: 600 }}>loss</span>, apply the
                    passive loss rules under{' '}
                    <span style={{ fontWeight: 600 }}> Form 8582</span> before
                    reporting it on{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Schedule E (Form 1040)
                    </span>
                    . If it shows{' '}
                    <span style={{ fontWeight: 600 }}>income</span>, report it
                    on <span style={{ fontWeight: 600 }}> Schedule E</span>. If
                    the partnership is a{' '}
                    <span style={{ fontWeight: 600 }}> PTP</span>, follow the
                    special PTP reporting rules instead.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 4a – Guaranteed Payments for Services
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box4a-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box4a-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box4a-img.png"
                    loading="lazy"
                    alt=" Schedule K-1 (Form 1065) Part III – Guaranteed Payments for Services"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter guaranteed payments made to the partner for services
                  provided to the partnership. These payments are generally{' '}
                  <span style={{ fontWeight: 600 }}> not passive income</span>{' '}
                  and are typically reported on{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Schedule E (Form 1040), Part II
                  </span>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 4b – Guaranteed Payments for Capital
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box4b-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box4b-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box4b-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Guaranteed Payments for Capital"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter guaranteed payments made to the partner for the use of
                  capital contributed to the partnership. Report these amounts
                  on{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Schedule E (Form 1040), Part II
                  </span>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 4c – Total Guaranteed Payments
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box4c-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box4c-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box4c-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Total Guaranteed Payments"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the total guaranteed payments by combining the amounts
                  reported on Lines 4a and 4b.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 5 – Interest Income
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box5-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box5-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box5-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Interest Income"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Enter the partner's share of taxable interest income earned by
                  the partnership during the tax year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  <span style={{ fontWeight: 600 }}>Example:</span> If the
                  partnership earned{' '}
                  <span style={{ fontWeight: 600 }}> $2,000</span> of taxable
                  interest from a business savings account and the partner’s
                  share is <span style={{ fontWeight: 600 }}> 25%,</span> enter{' '}
                  <span style={{ fontWeight: 600 }}> $500</span> in Box 5.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 6a – Ordinary Dividends
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box6a-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box6a-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box6a-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Ordinary Dividends"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the partner's share of ordinary dividend income received
                  by the partnership. Individuals generally report this amount
                  on{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Form 1040 or 1040-SR, line 3b
                  </span>
                  .
                </Typography>
                <Alert
                  severity="info"
                  id="who"
                  icon={<InfoOutlinedIcon />}
                  sx={{ mb: 4, borderLeft: '3px solid #0288d1' }}
                >
                  <b>Tip:</b> If part of the dividend relates to{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    PTEP (Previously Taxed Earnings and Profits)
                  </span>{' '}
                  from a foreign corporation, that portion may{' '}
                  <span style={{ fontWeight: 600 }}>not be taxable again</span>.
                  Use{' '}
                  <span style={{ fontWeight: 600 }}> Schedule K-3, Part V</span>{' '}
                  to determine any amount that should be excluded from gross
                  income.
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 6b – Qualified Dividends
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box6b-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box6b-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box6b-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Qualified Dividends"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the partner's share of qualified dividends that may be
                  eligible for preferential tax rates. Individuals generally
                  report this amount on{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Form 1040 or 1040-SR, line 3a
                  </span>
                  .
                </Typography>
                <Alert
                  severity="info"
                  id="who"
                  icon={<InfoOutlinedIcon />}
                  sx={{ mb: 4, borderLeft: '3px solid #0288d1' }}
                >
                  <b>Tip:</b> Qualified dividends are generally{' '}
                  <span style={{ fontWeight: 600 }}>
                    not included in investment income
                  </span>{' '}
                  . However, you may elect to include some or all of them when
                  completing <span style={{ fontWeight: 600 }}>Form 4952</span>
                </Alert>
                <Alert
                  // icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Caution:</b> If you have{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    foreign-source qualified dividends,
                  </span>{' '}
                  see the{' '}
                  <span style={{ fontWeight: 600 }}>
                    Partner’s Instructions for Schedule K-3
                  </span>{' '}
                  for additional details. The partnership will also attach a
                  statement showing any dividends in{' '}
                  <span style={{ fontWeight: 600 }}> Box 6a or 6b</span> that
                  may qualify for special{' '}
                  <span style={{ fontWeight: 600 }}> dividend deductions</span>{' '}
                  under sections{' '}
                  <span style={{ fontWeight: 600 }}> 243, 245, or 245A,</span>{' '}
                  or that are treated as{' '}
                  <span style={{ fontWeight: 600 }}> hybrid dividends</span>.
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 6c – Dividend Equivalents
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box6c-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box6c-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box6c-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Dividend Equivalents"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter any dividend equivalent payments allocated to the
                  partner, if applicable. This information is mainly provided
                  for <span style={{ fontWeight: 600 }}> non-U.S. persons</span>{' '}
                  and certain{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    domestic partnerships
                  </span>{' '}
                  that may need to treat these amounts as{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    U.S. source dividends
                  </span>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 7 – Royalties
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box7-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box7-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box7-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Royalties"
                    width={230}
                    height={41}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the partner's share of royalty income received by the
                  partnership from intellectual property, natural resources, or
                  similar assets. Report royalties on{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Schedule E (Form 1040), line 4
                  </span>
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 8 – Net Short-Term Capital Gain (Loss)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box8-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box8-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box8-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Net Short-Term Capital Gain (Loss)"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the partner's share of net short-term capital gain or
                  loss from assets held for one year or less. Report the
                  partner’s net short-term capital gain or loss on Schedule D
                  (Form 1040), line 5.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 9a – Net Long-Term Capital Gain (Loss)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box9a-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box9a-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box9a-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Net Long-Term Capital Gain (Loss)"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Enter the partner's share of net long-term capital gain or
                  loss from assets held for more than one year. Report the net
                  long-term capital gain (loss) on Schedule D (Form 1040), line
                  12.
                </Typography>
                <Alert
                  // icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Caution:</b> If you have a foreign source of net long-term
                  capital gain or loss, see{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Schedule K-3 instructions. Boxes 9b and 9c
                  </span>{' '}
                  report{' '}
                  <span style={{ fontWeight: 600 }}>
                    collectibles gain (28%)
                  </span>{' '}
                  and{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    unrecaptured section 1250 gain;
                  </span>{' '}
                  if you sold your partnership interest, related amounts may
                  also appear in{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Box 20, codes AC and AD.{' '}
                  </span>{' '}
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 9b – Collectibles (28%) Gain (Loss)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box9b-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box9b-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box9b-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Collectibles (28%) Gain (Loss)"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Enter the partner's share of gain or loss from collectibles
                  subject to the 28% capital gains tax rate Worksheet (Schedule
                  D (Form 1040) Instructions, line 18).
                </Typography>
                <Alert
                  // icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Caution:</b> If you have any foreign source net long-term
                  capital gain or loss, see Schedule K-3 instructions for
                  additional details
                </Alert>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 9c – Unrecaptured Section 1250 Gain
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box9c-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box9c-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box9c-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Unrecaptured Section 1250 Gain"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the partner's share of unrecaptured Section 1250 gain
                  related to depreciable real property. Report your share of
                  unrecaptured section 1250 gain on the Schedule D (Form 1040)
                  Unrecaptured Section 1250 Gain Worksheet (line 19)
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 10 – Net Section 1231 Gain (Loss)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box10-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box10-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box10-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Net Section 1231 Gain (Loss)"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    Enter the partner's share of Section 1231 gain or loss from
                    the sale or exchange of qualifying business property.
                  </li>
                  <li>
                    If it is a gain or non-passive loss, report it on Form 4797,
                    line 2 (column g). If it is a passive loss, apply Form 8582
                    limits before reporting. If it is from multiple activities,
                    the partnership will provide a separate statement.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 11 – Other Income (Loss)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box11-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box11-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box11-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Other Income (Loss)"
                    width={230}
                    height={82}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Report any other separately stated income or loss of items not
                  included on previous lines. Refer to{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/i1065sk1.pdf"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    IRS instructions
                  </Link>{' '}
                  for more details.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 12 – Section 179 Deduction
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box12-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box12-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box12-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Section 179 Deduction"
                    width={230}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Enter the partner's share of the Section 179 deduction
                  allocated by the partnership for qualifying business property.
                  complete Part I of{' '}
                  <Link
                    href="/resources/business-tax/form-4562/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 4562
                  </Link>{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    (Depreciation and Amortization)
                  </span>
                  . Your share of qualified enterprise zone or qualified real
                  property will be shown in an attached statement from the
                  partnership.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    If the deduction is from a{' '}
                    <span style={{ fontWeight: 600 }}> passive activity,</span>{' '}
                    report it using{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Form 8582 instructions
                    </span>
                    .
                  </li>
                  <li>
                    If it is{' '}
                    <span style={{ fontWeight: 600 }}> not passive,</span>{' '}
                    report it in{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Schedule E (Form 1040), line 28, column (j).
                    </span>
                  </li>
                  <li>
                    If{' '}
                    <span style={{ fontWeight: 600 }}>
                      Item D of Schedule K-1 is checked,
                    </span>{' '}
                    follow the rules for{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Publicly Traded Partnerships (PTPs)
                    </span>
                    instead.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 13 – Other Deductions
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box13-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box13-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box13-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Other Deductions"
                    width={230}
                    height={122}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Report the partner's share of separately stated deductions
                  using the applicable IRS codes. Refer to{' '}
                  <span style={{ fontWeight: 600 }}> IRS instructions</span> for
                  more details.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 14 – Self-Employment Earnings (Loss)
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box14-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box14-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box14-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Self-Employment Earnings (Loss)"
                    width={219}
                    height={82}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Enter the partner's share of self-employment earnings or loss
                  that may be subject to self-employment tax. Use the applicable
                  IRS codes.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 15 – Credits
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box15-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box15-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box15-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Credits"
                    width={218}
                    height={82}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Report the partner's share of tax credits allocated by the
                  partnership. Use the applicable IRS codes and refer to IRS
                  instructions.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 16 – Schedule K-3 Attached
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box16-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box16-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box16-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) – Schedule K-3 Attached"
                    width={218}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.5 } }}>
                  <li>
                    Check this box if Schedule K-3 is attached to provide
                    additional international tax information to the partner.
                  </li>
                  <li>
                    If the box is unchecked, the partnership will provide a
                    separate statement with the Schedule K-1 indicating that
                    Schedule K-3 is issued only upon request.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 17 – Alternative Minimum Tax (AMT) Items
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box17-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box17-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box17-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Alternative Minimum Tax (AMT) Items"
                    width={218}
                    height={122}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Report any items that affect the partner's Alternative Minimum
                  Tax (AMT) calculation. Refer to the IRS instruction for
                  applicable codes and amounts.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 18 – Tax-Exempt Income and Nondeductible Expenses
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box18-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box18-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box18-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III—Tax-Exempt Income and Non-deductible Expenses"
                    width={218}
                    height={142}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Report the partner's share of tax-exempt income and
                  nondeductible expenses separately. These items may affect the
                  partner's basis and other tax calculations.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 19 – Distributions
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box19-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box19-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box19-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Distributions"
                    width={218}
                    height={82}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Enter the total cash and property distributions made to the
                  partner during the tax year. These amounts may reduce the
                  partner's basis in the partnership. The amounts reported using
                  codes for more details see IRS instructions.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 20 – Other Information
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box20-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box20-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box20-img.png"
                    loading="lazy"
                    alt=" Schedule K-1 (Form 1065) Part III – Other Information"
                    width={218}
                    height={182}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Report any additional tax information required by the IRS
                  using the applicable codes. Refer for more details see IRS
                  instructions.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 21 – Foreign Taxes Paid or Accrued
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box21-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box21-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box21-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) Part III – Foreign Taxes Paid or Accrued"
                    width={218}
                    height={42}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Enter the partner's share of foreign taxes paid or accrued by
                  the partnership. This information may be used to claim a
                  foreign tax credit or deduction.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 22 – More Than One Activity for At-Risk Purposes
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box22-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box22-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box22-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) – More Than One Activity for At-Risk Purposes"
                    width={445}
                    height={23}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Check this box if the partnership has multiple activities that
                  require separate at-risk calculations. For more details, refer
                  to the{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/i1065sk1.pdf#page=8"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    At-Risk Limitations rules
                  </Link>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.8, fontWeight: 600 }}>
                  Box 23 – More Than One Activity for Passive Activity Purposes
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-part3-box23-img.webp" />
                  <source srcSet="/assets/images/schk1-part3-box23-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-part3-box23-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1065) – More Than One Activity for Passive Activity Purposes"
                    width={446}
                    height={23}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Check this box if the partnership has multiple passive
                  activities. Use the attached statement to determine how each
                  activity should be reported on the partner's tax return. For
                  more details, refer to the{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/i1065sk1.pdf#page=9"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Passive Activity Limitations rules
                  </Link>
                  .
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="schk"
                >
                  Schedule K vs. Schedule K-1: What's the Difference?
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  Partners often confuse these two related schedules. Schedule K
                  is the summary schedule attached to Form 1065 that reports the
                  partnership's total share of income, deductions, and credits
                  across all partners combined. Schedule K-1, on the other hand,
                  is the individual statement that breaks out each specific
                  partner's allocated portion. Think of Schedule K as the whole
                  pie, and each K-1 as an individual slice — they must reconcile
                  to the same totals.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="rules"
                >
                  At-Risk Rules and Passive Activity Rules
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Two additional limitations apply to partnership losses
                  reported on a K-1 before they can be deducted on a partner's
                  return:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    At-Risk Rules (Section 465):
                  </span>{' '}
                  Partners can only deduct losses to the extent they are "at
                  risk" — meaning the amount they could actually lose. Amounts
                  at risk generally include cash contributed, the adjusted basis
                  of property contributed, and certain recourse debt.
                  Nonrecourse debt (except qualified nonrecourse financing
                  secured by real property) typically does not increase a
                  partner's at-risk amount. Partners use{' '}
                  <Link
                    href="https://www.irs.gov/forms-pubs/about-form-6198"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 6198
                  </Link>{' '}
                  to calculate and report at-risk limitations.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Passive Activity Loss Rules (Section 469):
                  </span>{' '}
                  Losses from passive activities can only offset income from
                  other passive activities. A partner is generally passive in a
                  partnership if they do not materially participate in the
                  partnership's activities. Limited partners are presumed
                  passive. Excess passive losses are suspended and carried
                  forward to future years when passive income is available or
                  the activity is fully disposed of. These limitations are
                  calculated using{' '}
                  <Link
                    href="https://www.irs.gov/forms-pubs/about-form-8582"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 8582
                  </Link>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  These rules interact with each other and with basis
                  limitations, meaning a loss reported on a K-1 may face
                  multiple layers of limitation before it can actually reduce
                  taxable income.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="whento"
                >
                  When to Expect Your Schedule K-1
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Unlike W-2s and 1099s, which are due to recipients by January
                  31, Schedule K-1 forms for partnerships are tied to the
                  partnership's tax filing deadline.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}> Partnerships filing</span>{' '}
                  on time must issue K-1s by{' '}
                  <span style={{ fontWeight: 600 }}>March 15</span> (or the next
                  business day if March 15 falls on a weekend or holiday — for
                  the 2025 tax year, the deadline is{' '}
                  <span style={{ fontWeight: 600 }}>March 16, 2026</span>).
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Partnerships that fail to file on time face a penalty of{' '}
                  <span style={{ fontWeight: 600 }}>
                    $255 per partner, per month
                  </span>{' '}
                  (up to 12 months). A separate penalty of{' '}
                  <span style={{ fontWeight: 600 }}>$330 per K-1</span> applies
                  for failure to furnish Schedule K-1s to partners on time.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If the partnership files for an extension using{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 7004,
                  </Link>{' '}
                  the due date extends to{' '}
                  <span style={{ fontWeight: 600 }}> September 15,</span> which
                  can significantly delay your ability to file your own personal
                  return.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Because of this timing issue, many partners who are waiting on
                  K-1s file for a personal tax extension using{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-4868-personal-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 4868
                  </Link>{' '}
                  to extend their own filing deadline to October 15. This is a
                  very common and completely acceptable practice.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.5 }}>
                  What to do if your K-1 is late:
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>
                    Contact the partnership's managing partner or tax preparer
                    directly.
                  </li>
                  <li>
                    If you believe you should receive a K-1 and cannot obtain
                    it, consult a tax professional about your options.
                  </li>
                  <li>
                    Do not simply omit partnership income from your return — all
                    pass-through income is reportable regardless of whether you
                    received the K-1.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Mistakes to Avoid with Schedule K-1
                </Typography>
                <Box component="ol" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Ignoring the footnotes and supplemental schedules.
                    </span>{' '}
                    Many K-1s come with attached statements that provide
                    additional detail beyond what fits in the boxes. Missing
                    this detail can lead to errors.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Failing to apply basis, at-risk, and passive activity
                      limitations.
                    </span>{' '}
                    Simply entering the loss from Box 1 without checking whether
                    you have sufficient basis, are at-risk, or qualify as an
                    active participant can result in an incorrect deduction that
                    may trigger an IRS notice.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Not tracking basis from year to year.
                    </span>{' '}
                    Basis tracking is the partner's responsibility, not the
                    partnership's. Failing to maintain an accurate basis
                    schedule makes it impossible to correctly determine the
                    taxability of future distributions or the gain or loss on a
                    future sale.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Missing state K-1 requirements.
                    </span>{' '}
                    Many states require separate state K-1s or adjustments. If
                    the partnership operates in multiple states, partners may
                    need to file nonresident state returns in those states. Do
                    not assume the federal K-1 covers your state tax
                    obligations.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Confusing distributions with income.
                    </span>{' '}
                    A distribution shown on the K-1 is not necessarily taxable
                    income. Whether it's taxable depends on your basis.
                    Conversely, allocated income is taxable even if you never
                    actually received a cash distribution.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Not reconciling with the prior year K-1.
                    </span>{' '}
                    Changes in profit/loss percentages, capital account
                    balances, and liability allocations from year to year should
                    be reviewed and understood before filing.
                  </li>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="real"
                >
                  Schedule K-1 and Real Estate Partnerships
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Partnerships that own real estate generate K-1s with some
                  unique characteristics. Rental real estate income or loss is
                  reported in Box 2 of the K-1, and any income or loss from the
                  <Link
                    href="/resources/business-tax/form-8825/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    IRS Form 8825
                  </Link>{' '}
                  (Rental Real Estate Income and Expenses of a Partnership)
                  flows through to this line. Real estate partnerships may also
                  generate significant depreciation deductions — including bonus
                  depreciation and cost segregation results — that are allocated
                  to partners via the K-1. The interplay between at-risk rules,
                  passive activity rules, and real estate professional status
                  makes real estate K-1s particularly complex and warrants
                  careful review.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="public"
                >
                  Publicly Traded Partnerships (PTPs) and K-1s
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Partners in{' '}
                  <span style={{ fontWeight: 600 }}>
                    Publicly Traded Partnerships (PTPs)
                  </span>{' '}
                  — also called master limited partnerships (MLPs) — receive
                  Schedule K-1s just like investors in private partnerships.
                  However, PTP K-1s come with unique complexities:
                </Typography>
                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Passive loss rules apply at the PTP level,
                    </span>{' '}
                    meaning losses from one PTP cannot offset income from
                    another PTP or other passive income — they can only offset
                    income from that same PTP.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Section 751 "hot asset" issues
                    </span>{' '}
                    are common with PTP dispositions and can convert what
                    appears to be a capital gain into ordinary income.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      State filing requirements
                    </span>{' '}
                    can be extensive, as PTPs often operate in many states.
                  </li>
                  <li>
                    K-1s from PTPs may arrive late and sometimes require amended
                    K-1s.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Investors in PTPs through brokerage accounts should consult a
                  tax advisor familiar with MLP taxation, as the complexity is
                  significantly higher than with a standard partnership
                  interest.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faq"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. Do I pay taxes on my K-1 income even if I didn't receive
                  any cash distribution?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes. Partnership income is taxable in the year it is earned by
                  the partnership, regardless of whether cash is actually
                  distributed to you. This is a fundamental aspect of
                  pass-through taxation.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Can a K-1 show a loss that I can deduct?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Potentially, but only after applying the basis limitation,
                  at-risk rules, and passive activity rules. If you pass all
                  three tests, the loss is deductible in the current year. If
                  not, it carries forward.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. What if I receive a K-1 after I've already filed my return?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  You should file an amended return (Form 1040-X) to include the
                  K-1 information. This is also why filing for a personal
                  extension using{' '}
                  <Link
                    href="/tax-extension/efile-irs-form-4868-personal-tax-extension-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 4868
                  </Link>{' '}
                  when you're waiting on K-1s is often a wise move.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. Is a K-1 the same as a 1099?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  No. A 1099 reports payments made directly to you (interest,
                  dividends, freelance income, etc.). A K-1 reports your share
                  of a pass-through entity's income, deductions, and credits —
                  items that were earned at the partnership level but are
                  taxable to you as a partner.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. Do I need to file in every state where the partnership
                  operates?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Possibly. If a partnership earns income in multiple states,
                  partners may have nonresident filing obligations in those
                  states. The K-1 or supplemental schedules should include
                  state-specific information, but consulting a tax professional
                  with multi-state experience is advisable.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  6. How do I find the cost basis of my partnership interest?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  You must track your basis yourself using historical K-1s, your
                  initial investment records, and records of any additional
                  contributions or distributions. The capital account shown on
                  the K-1 is not the same as tax basis, though it can be a
                  useful starting point if reported on a tax basis.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  7. What is the difference between Schedule K and Schedule K-1?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule K summarizes the total income, deductions, and
                  credits of the entire partnership. Schedule K-1 allocates each
                  individual partner's specific share of those totals. each
                  individual partner's specific share of those totals.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  8. Can my partnership e-file Form 1065?
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Yes — in fact, the IRS generally requires e-filing for
                  partnerships that file 10 or more returns of any type during
                  the year (including W-2s and 1099s). Partnerships with more
                  than 100 partners are also required to file electronically.
                  TaxZerone makes it easy to{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1065-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    e-file Form 1065 online
                  </Link>
                  , including automatic generation of Schedule K-1s for all
                  partners.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="key"
                >
                  Key IRS Resources for Schedule K-1 (Form 1065)
                </Typography>
                <Typography variant="body1">
                  The IRS publishes official guidance that every partner and tax
                  professional should be familiar with:
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Resource
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Description
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Link
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>
                            Schedule K-1 (Form 1065)
                          </TableCell>
                          <TableCell sx={{}}>Official IRS form</TableCell>
                          <TableCell>
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/f1065sk1.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Download PDF
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{}}>
                            Instructions for Schedule K-1 (Form 1065)
                          </TableCell>
                          <TableCell sx={{}}>
                            Line-by-line IRS guidance
                          </TableCell>

                          <TableCell>
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/i1065sk1.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Download PDF
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>Form 1065</TableCell>
                          <TableCell sx={{}}>
                            U.S. Return of Partnership Income
                          </TableCell>

                          <TableCell>
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/f1065.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Download PDF
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{}}>
                            Instructions for Form 1065
                          </TableCell>
                          <TableCell sx={{}}>
                            IRS instructions for the partnership return
                          </TableCell>

                          <TableCell>
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/i1065.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Download PDF
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>Publication 541 </TableCell>
                          <TableCell sx={{}}>
                            IRS guide to partnership taxation
                          </TableCell>

                          <TableCell>
                            <Link
                              href="https://www.irs.gov/publications/p541"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              View on IRS.gov
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{}}>Form 8995 / 8995-A</TableCell>
                          <TableCell sx={{}}>
                            Qualified Business Income Deduction
                          </TableCell>

                          <TableCell>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-form-8995"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              About Form 8995
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{}}>Form 6198 </TableCell>
                          <TableCell sx={{}}>At-Risk Limitations</TableCell>

                          <TableCell>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-form-6198"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              About Form 6198
                            </Link>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{}}>Form 8582 </TableCell>
                          <TableCell sx={{}}>
                            Passive Activity Loss Limitations
                          </TableCell>

                          <TableCell>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-form-8582"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              About Form 8582
                            </Link>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.8,
                    scrollMarginTop: 83,
                  }}
                  id="internal"
                >
                  TaxZerone Internal Resources for Partnerships
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  If you're navigating partnership tax compliance, the following
                  TaxZerone resources provide additional guidance:
                </Typography>

                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Resource
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Description
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/business-tax/efile-irs-form-1065-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              E-File Form 1065 Online
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Securely e-file your partnership return and generate
                            K-1s{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/resources/business-tax/form-1065-instructions/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 1065 Instructions
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Step-by-step walkthrough of the partnership return
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/resources/business-tax/form-1065-filing-deadlines-and-penalties-guide/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 1065 Filing Deadlines & Penalties
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Key due dates and penalty guidance
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/resources/business-tax/form-4797/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 4797
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Reporting sales of business property
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/resources/business-tax/form-4562/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 4562
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Depreciation and Section 179 deduction
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/resources/business-tax/form-8825/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 8825
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Rental real estate income and expenses
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/resources/business-tax/form-1125-a/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 1125-A
                            </Link>{' '}
                          </TableCell>
                          <TableCell>Cost of goods sold</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/resources/business-tax/form-1125-e/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 1125-E
                            </Link>{' '}
                          </TableCell>
                          <TableCell>Compensation of officers</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/resources/business-tax/form-1120s-vs-form-1065-comparison/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 1120-S vs. Form 1065
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            S corp vs. partnership comparison{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 7004 – Business Tax Extension
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Request a 6-month extension for Form 1065{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            {' '}
                            <Link
                              href="/tax-extension/efile-irs-form-4868-personal-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 4868 – Personal Tax Extension
                            </Link>{' '}
                          </TableCell>
                          <TableCell>
                            Extend your personal return while waiting for
                            K-1s{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 0.8,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Ready to e-file Form 1065 & distribute accurate Schedule K-1s to
              your partners?
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Stay IRS compliant and report each partner’s share of income,
              deductions, and credits with confidence.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=schk1-1065`}
              >
                Start E-filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1065SchK1;
